import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function OfferSection() {
  return <section id="offer-section" className="py-24 px-6 bg-white" data-id="element-100">
      <div className="max-w-5xl mx-auto" data-id="element-101">
        <FadeIn data-id="element-102">
          <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-2xl border border-amber/20 overflow-hidden relative" data-id="element-103">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-104">
              <div data-id="element-105">
                <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-106">
                  Tus riñones son tu filtro de vida.
                </h2>
                <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-107">
                  Si ellos se detienen, tu vida se detiene. Este no es un gasto,
                  es una inversión en tu autonomía.
                </p>

                <div className="bg-white p-6 rounded-2xl shadow-inner mb-8 border border-gray-100" data-id="element-108">
                  <p className="text-lg text-gray-600 mb-2" data-id="element-109">
                    Obtén el Protocolo de Rescate para Tus Riñones con todos los
                    anexos incluidos hoy mismo.
                  </p>
                  <p className="text-2xl font-bold text-forest" data-id="element-110">
                    Precio Especial de Lanzamiento:
                  </p>
                  <p className="text-6xl font-black text-amber mt-2" data-id="element-111">$8 USD</p>
                </div>

                <CTAButton className="w-full text-lg md:text-xl py-6" onClick={() => {
                window.open('https://www.tres33group.com/cart/43089344135229:1', '_blank');
              }} data-id="element-112">
                  ¡SÍ, QUIERO RESCATAR MIS RIÑONES HOY MISMO!
                  <span className="block text-sm font-normal mt-1 opacity-90" data-id="element-113">
                    (Acceso inmediato al PDF y todos los materiales por solo $8)
                  </span>
                </CTAButton>
              </div>

              <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white" data-id="element-114">
                <img src="https://cdn.magicpatterns.com/uploads/jJtAf6N5nAkiVAVHSkyMLJ/Rescate_renal_y_bienestar_personal.png" alt="Hombre relajado bebiendo agua con limón y leyendo el protocolo" className="w-full h-auto object-cover" data-id="element-115" />
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}